import React from 'react';
import { useTranslation } from 'react-i18next';
import { EventAnalyticsTicketScansByTierDataPointDto } from 'legacy/events/types';

interface TicketStatsProps {
  tierScansData?: EventAnalyticsTicketScansByTierDataPointDto;
  maxAttendance?: string | number;
  requiresApproval?: boolean;
  questions?: any[];
  testId?: string;
  purchases?: number;
}

const TicketStats: React.FC<TicketStatsProps> = ({
  tierScansData,
  maxAttendance,
  requiresApproval,
  questions,
  testId,
  purchases
}) => {
  const { t } = useTranslation(['events']);

  return (
    <div className="mt-4 flex flex-col gap-1">
      <div className="flex items-center text-[#575757] mr-4 text-sm">
        <span className="mr-1">🎟</span>
        <span>{purchases || 0}</span>
        {typeof maxAttendance === 'number' && maxAttendance > 0 && (
          <span data-testid={`${testId}-maxAttendance`}>/{maxAttendance}</span>
        )}
        <span className="ml-1">
          {t('events:pricingTiers.tierManagement.soldLabel')}
        </span>
      </div>
      <div className="flex items-center text-[#575757] mr-4 text-sm">
        <span className="mr-1">
          <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.666016 12V8.66667H1.99935V10.6667H3.99935V12H0.666016ZM11.9993 12V10.6667H13.9993V8.66667H15.3327V12H11.9993ZM2.66602 10V2H3.99935V10H2.66602ZM4.66602 10V2H5.33268V10H4.66602ZM6.66602 10V2H7.99935V10H6.66602ZM8.66602 10V2H10.666V10H8.66602ZM11.3327 10V2H11.9993V10H11.3327ZM12.666 10V2H13.3327V10H12.666ZM0.666016 3.33333V0H3.99935V1.33333H1.99935V3.33333H0.666016ZM13.9993 3.33333V1.33333H11.9993V0H15.3327V3.33333H13.9993Z"
              fill="#575757"
            />
          </svg>
        </span>
        <span>{tierScansData?.ticketsScanned || 0}</span>
        <span className="ml-1">
          {t('events:pricingTiers.tierManagement.scannedLabel')}
        </span>
      </div>

      {requiresApproval && (
        <div className="text-sm text-[#575757]">
          👍 {t('events:pricingTiers.tierManagement.requiresApproval')}{' '}
          {questions?.length > 0 && `(${questions.length} q's)`}
        </div>
      )}
    </div>
  );
};

export default TicketStats;
